import { apiClient } from './apiClient';

import type {
  DeviceTrustPayload,
  DeviceTrustResponse,
  DeviceTrustVerifyResponse,
  OtpRequestResponse,
  OtpVerifyResponse,
  RefreshTokenResponse,
  RequestOtpPayload,
  SessionResponse,
  VerifyDeviceTrustPayload,
  VerifyOtpPayload,
} from '@/types/auth.types';

export const authService = {
  requestOtp: (payload: RequestOtpPayload) => apiClient.post<OtpRequestResponse>('/auth/otp/request', payload),

  verifyOtp: (payload: VerifyOtpPayload) => apiClient.post<OtpVerifyResponse>('/auth/otp/verify', payload),

  createDeviceTrust: (payload: DeviceTrustPayload) =>
    apiClient.post<DeviceTrustResponse>('/auth/device-trust', payload),

  verifyDeviceTrust: (payload: VerifyDeviceTrustPayload) =>
    apiClient.post<DeviceTrustVerifyResponse>('/auth/device-trust/verify', payload),

  refreshToken: (refreshToken: string) => apiClient.post<RefreshTokenResponse>('/auth/refresh', { refreshToken }),

  getSession: () => apiClient.get<SessionResponse>('/auth/session'),
};
